const advancementChart = {
  "5th Edition": [
    { level: 1, experience: 0, next: 300, proficiencyBonus: 2 },
    { level: 2, experience: 300, next: 900, proficiencyBonus: 2 },
    { level: 3, experience: 900, next: 2700, proficiencyBonus: 2 },
    { level: 4, experience: 2700, next: 6500, proficiencyBonus: 2 },
    { level: 5, experience: 6500, next: 14000, proficiencyBonus: 3 },
    { level: 6, experience: 14000, next: 23000, proficiencyBonus: 3 },
    { level: 7, experience: 23000, next: 34000, proficiencyBonus: 3 },
    { level: 8, experience: 34000, next: 48000, proficiencyBonus: 3 },
    { level: 9, experience: 48000, next: 64000, proficiencyBonus: 4 },
    { level: 10, experience: 64000, next: 85000, proficiencyBonus: 4 },
    { level: 11, experience: 85000, next: 100000, proficiencyBonus: 4 },
    { level: 12, experience: 100000, next: 120000, proficiencyBonus: 4 },
    { level: 13, experience: 120000, next: 140000, proficiencyBonus: 5 },
    { level: 14, experience: 140000, next: 165000, proficiencyBonus: 5 },
    { level: 15, experience: 165000, next: 195000, proficiencyBonus: 5 },
    { level: 16, experience: 195000, next: 225000, proficiencyBonus: 5 },
    { level: 17, experience: 225000, next: 265000, proficiencyBonus: 6 },
    { level: 18, experience: 265000, next: 305000, proficiencyBonus: 6 },
    { level: 19, experience: 305000, next: 355000, proficiencyBonus: 6 },
    { level: 20, experience: 355000, next: 999999, proficiencyBonus: 6 }
  ],
  "PF Playtest": [
    { level: 1, experience: 0, next: 1000 },
    { level: 2, experience: 1000, next: 2000 },
    { level: 3, experience: 2000, next: 3000 },
    { level: 4, experience: 3000, next: 4000 },
    { level: 5, experience: 4000, next: 5000 },
    { level: 6, experience: 5000, next: 6000 },
    { level: 7, experience: 6000, next: 7000 },
    { level: 8, experience: 7000, next: 8000 },
    { level: 9, experience: 8000, next: 9000 },
    { level: 10, experience: 9000, next: 10000 },
    { level: 11, experience: 10000, next: 11000 },
    { level: 12, experience: 11000, next: 12000 },
    { level: 13, experience: 12000, next: 13000 },
    { level: 14, experience: 13000, next: 14000 },
    { level: 15, experience: 14000, next: 15000 },
    { level: 16, experience: 15000, next: 16000 },
    { level: 17, experience: 16000, next: 17000 },
    { level: 18, experience: 17000, next: 18000 },
    { level: 19, experience: 18000, next: 19000 },
    { level: 20, experience: 19000, next: 20000 }
  ],
  PFRPG2: [
    { level: 1, experience: 0, next: 1000 },
    { level: 2, experience: 1000, next: 2000 },
    { level: 3, experience: 2000, next: 3000 },
    { level: 4, experience: 3000, next: 4000 },
    { level: 5, experience: 4000, next: 5000 },
    { level: 6, experience: 5000, next: 6000 },
    { level: 7, experience: 6000, next: 7000 },
    { level: 8, experience: 7000, next: 8000 },
    { level: 9, experience: 8000, next: 9000 },
    { level: 10, experience: 9000, next: 10000 },
    { level: 11, experience: 10000, next: 11000 },
    { level: 12, experience: 11000, next: 12000 },
    { level: 13, experience: 12000, next: 13000 },
    { level: 14, experience: 13000, next: 14000 },
    { level: 15, experience: 14000, next: 15000 },
    { level: 16, experience: 15000, next: 16000 },
    { level: 17, experience: 16000, next: 17000 },
    { level: 18, experience: 17000, next: 18000 },
    { level: 19, experience: 18000, next: 19000 },
    { level: 20, experience: 19000, next: 20000 }
  ],
  "Embers RPG": [
    { level: 1, experience: 0, next: 1000 },
    { level: 2, experience: 1000, next: 2000 },
    { level: 3, experience: 2000, next: 3000 },
    { level: 4, experience: 3000, next: 4000 },
    { level: 5, experience: 4000, next: 5000 },
    { level: 6, experience: 5000, next: 6000 },
    { level: 7, experience: 6000, next: 7000 },
    { level: 8, experience: 7000, next: 8000 },
    { level: 9, experience: 8000, next: 9000 },
    { level: 10, experience: 9000, next: 10000 },
    { level: 11, experience: 10000, next: 11000 },
    { level: 12, experience: 11000, next: 12000 },
    { level: 13, experience: 12000, next: 13000 },
    { level: 14, experience: 13000, next: 14000 },
    { level: 15, experience: 14000, next: 15000 },
    { level: 16, experience: 15000, next: 16000 },
    { level: 17, experience: 16000, next: 17000 },
    { level: 18, experience: 17000, next: 18000 },
    { level: 19, experience: 18000, next: 19000 },
    { level: 20, experience: 19000, next: 20000 }
  ],
  PFRPG: [
    {
      level: 1,
      slow: { experience: 0, next: 3000 },
      medium: { experience: 0, next: 2000 },
      fast: { experience: 0, next: 1300 }
    },
    {
      level: 2,
      slow: { experience: 3000, next: 7500 },
      medium: { experience: 2000, next: 5000 },
      fast: { experience: 1300, next: 3300 }
    },
    {
      level: 3,
      slow: { experience: 7500, next: 14000 },
      medium: { experience: 5000, next: 9000 },
      fast: { experience: 3300, next: 6000 }
    },
    {
      level: 4,
      slow: { experience: 14000, next: 23000 },
      medium: { experience: 9000, next: 15000 },
      fast: { experience: 6000, next: 10000 }
    },
    {
      level: 5,
      slow: { experience: 23000, next: 35000 },
      medium: { experience: 15000, next: 23000 },
      fast: { experience: 10000, next: 15000 }
    },
    {
      level: 6,
      slow: { experience: 35000, next: 53000 },
      medium: { experience: 23000, next: 35000 },
      fast: { experience: 15000, next: 23000 }
    },
    {
      level: 7,
      slow: { experience: 53000, next: 77000 },
      medium: { experience: 35000, next: 51000 },
      fast: { experience: 23000, next: 34000 }
    },
    {
      level: 8,
      slow: { experience: 77000, next: 115000 },
      medium: { experience: 51000, next: 75000 },
      fast: { experience: 34000, next: 50000 }
    },
    {
      level: 9,
      slow: { experience: 115000, next: 160000 },
      medium: { experience: 75000, next: 105000 },
      fast: { experience: 50000, next: 71000 }
    },
    {
      level: 10,
      slow: { experience: 160000, next: 235000 },
      medium: { experience: 105000, next: 155000 },
      fast: { experience: 71000, next: 105000 }
    },
    {
      level: 11,
      slow: { experience: 235000, next: 330000 },
      medium: { experience: 155000, next: 220000 },
      fast: { experience: 105000, next: 145000 }
    },
    {
      level: 12,
      slow: { experience: 330000, next: 475000 },
      medium: { experience: 220000, next: 315000 },
      fast: { experience: 145000, next: 210000 }
    },
    {
      level: 13,
      slow: { experience: 475000, next: 665000 },
      medium: { experience: 315000, next: 445000 },
      fast: { experience: 210000, next: 295000 }
    },
    {
      level: 14,
      slow: { experience: 665000, next: 955000 },
      medium: { experience: 445000, next: 635000 },
      fast: { experience: 295000, next: 425000 }
    },
    {
      level: 15,
      slow: { experience: 955000, next: 1350000 },
      medium: { experience: 635000, next: 890000 },
      fast: { experience: 425000, next: 600000 }
    },
    {
      level: 16,
      slow: { experience: 1350000, next: 1900000 },
      medium: { experience: 890000, next: 1300000 },
      fast: { experience: 600000, next: 850000 }
    },
    {
      level: 17,
      slow: { experience: 1900000, next: 2700000 },
      medium: { experience: 1300000, next: 1800000 },
      fast: { experience: 850000, next: 1200000 }
    },
    {
      level: 18,
      slow: { experience: 2700000, next: 3850000 },
      medium: { experience: 1800000, next: 2550000 },
      fast: { experience: 1200000, next: 1700000 }
    },
    {
      level: 19,
      slow: { experience: 3850000, next: 5350000 },
      medium: { experience: 2550000, next: 3600000 },
      fast: { experience: 1700000, next: 2400000 }
    },
    {
      level: 20,
      slow: { experience: 5350000, next: 9999999 },
      medium: { experience: 3600000, next: 9999999 },
      fast: { experience: 2400000, next: 9999999 }
    }
  ]
};

const getAdvancement = (ruleset, exp, speed = "medium") => {
  let level;
  if (ruleset === "5th Edition" || ruleset === "5e24" || ruleset === "PFRPG2" || ruleset === "PF Playtest" || ruleset === "Embers RPG") {
    level = advancementChart[ruleset].find(
      x => x.experience <= exp && x.next > exp
    );
  } else {
    level = advancementChart[ruleset].find(
      x => x[speed].experience <= exp && x[speed].next > exp
    );
  }
  level = level || advancementChart[0];
  return level;
};

const removeChildDetail = vm => {
  vm.$nextTick(() => {
    let child = document.getElementById("child");
    if (child && child.getElementsByTagName("p").length > 2) {
      child.removeChild(child.getElementsByTagName("p")[0]);
    }
  });
};

let rpgv = {};

rpgv.removeChildDetail = removeChildDetail;
rpgv.rulesetOptions = [
  "5th Edition",
  "5e24",
  "PFRPG",
  "PFRPG2",
  "Solarian Conflict",
  "PF Playtest",
  "Savage Embers",
  "Savage Worlds",
  "Embers RPG"
];
rpgv.ruleTypes = ["Ability", "Feat"];
rpgv.ruleTypesPlural = { Ability: "Abilities", Feat: "Feats" };

rpgv.actionTypes = [
  "",
  "Melee",
  "Range",
  "Spell",
  "Power",
  "Special",
  "Potion",
  "Magic Item"
];
rpgv.itemTypes = [
  "",
  "Currency",
  "Weapon",
  "Armor",
  "Gear",
  "Tool",
  "Magic Item",
  "Consumable",
  "Vehicle"
];
rpgv.itemTypesPlural = {
  Weapon: "Weapons",
  Tool: "Tools",
  "Magic Item": "Magic Items",
  Consumable: "Consumables",
  Vehicle: "Vehicles"
};
rpgv.spellSchools = [
  "",
  "Abjuration",
  "Conjuration",
  "Divination",
  "Enchantment",
  "Evocation",
  "Illusion",
  "Necromancy",
  "Transmutation"
];

rpgv.toggleModal = (_vm, el) => {
  _vm.$nextTick(() => {
    document.getElementById(el).click();
  });
};

rpgv.updateFromRef = data => {
  let blackList = ["_id", "_ref"];
  for (let k in data) {
    if (
      !blackList.includes(k) &&
      data.hasOwnProperty(k) &&
      data._ref.hasOwnProperty(k)
    ) {
      data[k] = data._ref[k];
      // console.log(`${k}: ${data[k]} / ${data._ref[k]}`)
    }
  }
};

rpgv.isD20 = ruleset => {
  let d20 = ["PFRPG", "3.5 Edition", "d20 Future", "d20 Modern"];
  let found = false;
  if (d20.indexOf(ruleset) > -1) {
    found = true;
  }
  return found;
};

rpgv.carriedWeight = items => {
  let itemWeights = [];
  items.filter(x => x.carried).forEach(item => {
    let quantity = Number.isFinite(item.quantity) ? item.quantity : 0;
    let weight = Number.isFinite(item.weight) ? item.weight : 0;
    itemWeights.push(quantity * weight);
  });
  var totalWeight = itemWeights.reduce((prevVal, val) => {
    return prevVal + val;
  }, 0);
  return totalWeight;
};

rpgv.d20 = {
  size: {
    Fine: { modifier: 8, fly: 8, stealth: 16 },
    Diminutive: { modifier: 4, fly: 6, stealth: 12 },
    Tiny: { modifier: 2, fly: 4, stealth: 8 },
    Small: { modifier: 1, fly: 2, stealth: 4 },
    Medium: { modifier: 0, fly: 0, stealth: 0 },
    Large: { modifier: -1, fly: -2, stealth: -4 },
    Huge: { modifier: -2, fly: -4, stealth: -8 },
    Gargantuan: { modifier: -4, fly: -6, stealth: -12 },
    Colossal: { modifier: -8, fly: -8, stealth: -16 }
  },

  alignment: [
    "",
    "Lawful Good",
    "Lawful Neutral",
    "Lawful Evil",
    "Neutral Good",
    "Neutral",
    "Neutral Evil",
    "Chaotic Good",
    "Chaotic Neutral",
    "Chaotic Evil"
  ],

  level: (ruleset, exp, speed = "medium") => {
    //ruleset = ruleset === "Solarian Conflict" ? "5th Edition" : ruleset;
    ruleset = ['5e24', 'Solarian Conflict'].includes(ruleset) ? '5th Edition' : ruleset;
    let advancement = getAdvancement(ruleset, exp, speed);
    let level = advancement ? advancement.level : 0;
    return level;
  },

  proficiencyBonus: exp => {
    let advancement = getAdvancement("5th Edition", exp);
    let proficiencyBonus = advancement ? advancement.proficiencyBonus : 2;
    return proficiencyBonus;
  },

  descriptor: item => {
    let ruleset = item.ruleset;
    if (['5e24', 'Solarian Conflict'].includes(ruleset)) ruleset = "5th Edition";

    let race = item.core.race || item.core.ancestry || "";

    let multiClass = /[0-9]+/.test(item.core.class);
    let klass = item.core.class || "";
    klass =
      !multiClass && klass
        ? `${klass} ${rpgv.d20.level(ruleset, item.core.experience)}`.trim()
        : klass;

    let description = race || klass ? `${race} ${klass}`.trim() : "Peasant";
    return description;
  },

  attributeBonus: attribute => {
    let total = 0;
    if (Number.isFinite(attribute.temp)) {
      total = Math.floor((attribute.temp - 10) / 2);
    } else if (Number.isFinite(attribute.score)) {
      total = Math.floor((attribute.score - 10) / 2);
    }
    return total;
  },

  armorClassDex: (armorClass, dexterity) => {
    let base = rpgv.d20.attributeBonus(dexterity);

    if (armorClass.armor) {
      if (armorClass.armor.medium && base > 2) base = 2;
      if (armorClass.armor.heavy && base > 0) base = 0;
      if (
        Number.isFinite(armorClass.armor.maxDex) &&
        base > armorClass.armor.maxDex
      )
        base = armorClass.armor.maxDex;
    }

    if (
      armorClass.shield &&
      Number.isFinite(armorClass.shield.maxDex) &&
      base > armorClass.shield.maxDex
    ) {
      base = armorClass.shield.maxDex;
    }

    return base;
  },

  armorClass: (ruleset, armorClass, dexterity, size) => {
    let base = ["PFRPG", "PFRPG2", "PF Playtest", "Emmbers RPG"].includes(ruleset) ? 10 : 0;

    let total = base + rpgv.d20.armorClassDex(armorClass, dexterity);
    if (armorClass.armor && Number.isFinite(armorClass.armor.bonus))
      total += armorClass.armor.bonus;
    if (
      armorClass.shield &&
      Number.isFinite(armorClass.shield.bonus) &&
      armorClass.shield.raised !== false
    )
      total += armorClass.shield.bonus;
    if (armorClass.magic && Number.isFinite(armorClass.magic.bonus))
      total += armorClass.magic.bonus;
    if (armorClass.natural && Number.isFinite(armorClass.natural.bonus))
      total += armorClass.natural.bonus;
    if (armorClass.deflection && Number.isFinite(armorClass.deflection.bonus))
      total += armorClass.deflection.bonus;
    if (armorClass.dodge && Number.isFinite(armorClass.dodge.bonus))
      total += armorClass.dodge.bonus;
    if (armorClass.misc && Number.isFinite(armorClass.misc.bonus))
      total += armorClass.misc.bonus;

    if (ruleset === "PFRPG" && size) total += rpgv.d20.size[size].modifier;

    return total;
  },

  touchArmorClass: (ruleset, armorClass, dexterity) => {
    let base = ["PFRPG", "PFRPG2", "PF Playtest", "Emmbers RPG"].includes(ruleset) ? 10 : 0;
    let total = base + rpgv.d20.armorClassDex(armorClass, dexterity);
    if (armorClass.armor && Number.isFinite(armorClass.armor.touchBonus))
      total += armorClass.armor.touchBonus;
    if (
      armorClass.shield &&
      Number.isFinite(armorClass.shield.touchBonus) &&
      armorClass.shield.raised !== false
    )
      total += armorClass.shield.touchBonus;
    return total;
  },

  armorClassTouch: (ruleset, armorClass, dexterity, size) => {
    let base = ["PFRPG", "PFRPG2", "PF Playtest", "Emmbers RPG"].includes(ruleset) ? 10 : 0;

    let total = base + rpgv.d20.armorClassDex(armorClass, dexterity);
    if (armorClass.magic && Number.isFinite(armorClass.magic.bonus))
      total += armorClass.magic.bonus;
    if (armorClass.deflection && Number.isFinite(armorClass.deflection.bonus))
      total += armorClass.deflection.bonus;
    if (armorClass.dodge && Number.isFinite(armorClass.dodge.bonus))
      total += armorClass.dodge.bonus;
    if (armorClass.misc && Number.isFinite(armorClass.misc.bonus))
      total += armorClass.misc.bonus;

    if (ruleset === "PFRPG" && size) total += rpgv.d20.size[size].modifier;

    return total;
  },

  armorClassFlatFooted: (ruleset, armorClass, dexterity, size) => {
    let base = ruleset === "PFRPG" ? 10 : 0;

    let total = base;
    if (armorClass.armor && Number.isFinite(armorClass.armor.bonus))
      total += armorClass.armor.bonus;
    if (armorClass.shield && Number.isFinite(armorClass.shield.bonus))
      total += armorClass.shield.bonus;
    if (armorClass.magic && Number.isFinite(armorClass.magic.bonus))
      total += armorClass.magic.bonus;
    if (armorClass.natural && Number.isFinite(armorClass.natural.bonus))
      total += armorClass.natural.bonus;
    if (armorClass.deflection && Number.isFinite(armorClass.deflection.bonus))
      total += armorClass.deflection.bonus;
    if (armorClass.misc && Number.isFinite(armorClass.misc.bonus))
      total += armorClass.misc.bonus;

    if (ruleset === "PFRPG" && size) total += rpgv.d20.size[size].modifier;

    return total;
  },

  attributeOptions: () => {
    let core = [
      "Strength",
      "Dexterity",
      "Constitution",
      "Intelligence",
      "Wisdom",
      "Charisma"
    ];
    let options = [];
    core.forEach(function (element) {
      options.push({ text: element, value: element.toLowerCase() });
    });
    return options;
  },

  getAttribute(attribute, attributes) {
    return attributes.find(x => x.name === attribute);
  },
  attackBonus(payload) {
    // item, attributes, proficiencyBonus, baseAttackBonus, size, ruleset
    if (payload.item.attack) {
      let bonus = 0;
      if (payload.item.attack.attribute)
        bonus += rpgv.d20.attributeBonus(
          rpgv.d20.getAttribute(
            payload.item.attack.attribute,
            payload.attributes
          )
        );
      if (payload.item.proficient && payload.proficiencyBonus)
        bonus += payload.proficiencyBonus;
      if (payload.item.proficient && payload.baseAttackBonus)
        bonus += payload.baseAttackBonus;
      if (payload.item.attack.misc)
        bonus += parseInt(payload.item.attack.misc, 10);
      if (payload.item.attack.magic)
        bonus += parseInt(payload.item.attack.magic, 10);
      if (payload.ruleset === "PFRPG" && payload.size)
        bonus += rpgv.d20.size[payload.size].modifier;

      return bonus;
    }
  },
  damageBonus(payload) {
    // item, attributes, size, proficiencyBonus, baseAttackBonus
    if (payload.item.damage) {
      let bonus = 0;
      if (payload.item.damage.attribute)
        bonus += rpgv.d20.attributeBonus(
          rpgv.d20.getAttribute(
            payload.item.damage.attribute,
            payload.attributes
          )
        );
      if (payload.item.damage.misc)
        bonus += parseInt(payload.item.damage.misc, 10);
      if (payload.item.damage.magic)
        bonus += parseInt(payload.item.damage.magic, 10);
      return bonus;
    }
  },

  health: payload => {
    payload = payload || {};

    if (payload.dead) {
      return "dead";
    }

    if (payload.deathSaves > 2) {
      return "dead";
    }

    if (payload.dying > 3) {
      return "dead";
    }

    if (payload.hitPoints) {
      if (payload.hitPoints.current <= parseInt(payload.constitution) * -1) {
        return "dead";
      }

      if (payload.hitPoints.current < 1) {
        return "unconcious";
      }

      if (
        payload.hitPoints.current <=
        parseInt(payload.hitPoints.maximum, 10) / 2
      ) {
        return "bloodied";
      }

      if (
        payload.hitPoints.current >
        parseInt(payload.hitPoints.maximum, 10) / 2 &&
        payload.hitPoints.current < payload.hitPoints.maximum
      ) {
        return "hurt";
      }
    }

    return "full";
  }
};

rpgv.install = Vue => {
  Vue.prototype.$rpgv = rpgv;
};

export default rpgv;
